import { Injectable, Signal, signal } from '@angular/core';
import { environment } from '@env/environment';

/** The only API host the sequential series writes are authorised against. */
export const SERIES_TEST_API_HOST = 'api.test.proffeo.net';

export interface SeriesEnvironment {
  production: boolean;
  APIEndPoint: string;
}

/** Series is available only in non-production builds talking to the test API. */
export function isSeriesAvailableIn(env: SeriesEnvironment): boolean {
  if (env.production) {
    return false;
  }

  try {
    return new URL(env.APIEndPoint).hostname === SERIES_TEST_API_HOST;
  } catch {
    return false;
  }
}

/**
 * TimeReportSeriesFeatureService - Single feature check for multi-day report series.
 *
 * Scope: Global (`providedIn: 'root'`).
 *
 * Usage: Read by the shared series form (to show or hide the series controls in the work-time and
 * absence dialogs) and by {@link TimeReportsDataService} (to refuse series writes when unavailable).
 */
@Injectable({ providedIn: 'root' })
export class TimeReportSeriesFeatureService {
  public readonly available: Signal<boolean> = signal(isSeriesAvailableIn(environment)).asReadonly();
}
